import { render, staticRenderFns } from "./TenantHistoryCard.vue?vue&type=template&id=43edbd81&scoped=true&"
import script from "./TenantHistoryCard.vue?vue&type=script&lang=js&"
export * from "./TenantHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./TenantHistoryCard.vue?vue&type=style&index=0&id=43edbd81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edbd81",
  null
  
)

export default component.exports